import { render } from "./ModalAddParceria.vue?vue&type=template&id=e805e654"
import script from "./ModalAddParceria.vue?vue&type=script&lang=js"
export * from "./ModalAddParceria.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__